var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.smsSent
        ? _c(
            "div",
            {
              staticClass: "item-edit",
              staticStyle: { "animation-delay": "2s" }
            },
            [
              _c("div", { staticClass: "mb-2" }, [
                _vm._v("Bitte gib hier den Code ein:")
              ]),
              _vm._v(" "),
              _c("b-input", {
                ref: "mobilePhoneCodeInput",
                staticClass: "w-auto",
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.confirmMobilePhone.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.mobilePhoneCode,
                  callback: function($$v) {
                    _vm.mobilePhoneCode = $$v
                  },
                  expression: "mobilePhoneCode"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c("Button", {
                    attrs: {
                      text: "Code bestätigen",
                      icon: "checkmark",
                      loading: _vm.saving,
                      disabled: !_vm.mobilePhoneCodeValid || _vm.saving
                    },
                    on: { click: _vm.confirmMobilePhone }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _c("div", [_vm._v("Mobilnummer falsch?")]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changeData.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Hier ändern")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _c("div", [_vm._v("Keine SMS bekommen?")]),
                _vm._v(" "),
                _c("div", [
                  _vm.smsSentAgain
                    ? _c("div", { staticClass: "success" }, [
                        _vm._v("Erfolgreich versendet")
                      ])
                    : !_vm.saving
                    ? _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.save(true)
                            }
                          }
                        },
                        [_vm._v("Hier nochmals senden")]
                      )
                    : _vm._e()
                ])
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "sections" },
            [
              _vm.checkData
                ? _c("div", [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3" }, [
                      _c("div", [
                        _c("span", { staticClass: "font-weight-extra-bold" }, [
                          _vm._v("Vorname:")
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.personalData.firstName) +
                            "\n\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "font-weight-extra-bold" }, [
                          _vm._v("Nachname:")
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.personalData.lastName) +
                            "\n\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "font-weight-extra-bold" }, [
                          _vm._v("Geburtsdatum:")
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm._f("dateByObject")(
                                _vm.personalData.dateOfBirth
                              )
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.mobilePhoneNumber
                        ? _c("div", [
                            _c(
                              "span",
                              { staticClass: "font-weight-extra-bold" },
                              [_vm._v("Mobilnummer:")]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm._f("phone")(_vm.mobilePhoneNumber)) +
                                "\n\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-3 text-right" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            model: {
                              value: _vm.checkDataOk,
                              callback: function($$v) {
                                _vm.checkDataOk = $$v
                              },
                              expression: "checkDataOk"
                            }
                          },
                          [_vm._v("Meine Daten stimmen")]
                        )
                      ],
                      1
                    )
                  ])
                : [
                    _vm.mobilePhoneAndPersonalDataNecessary
                      ? [
                          _c(
                            "section",
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("Phone", {
                                staticClass: "mt-4",
                                attrs: {
                                  meta: _vm.meta,
                                  "show-missing-error": false
                                },
                                model: {
                                  value: _vm.mobilePhoneNumber,
                                  callback: function($$v) {
                                    _vm.mobilePhoneNumber = $$v
                                  },
                                  expression: "mobilePhoneNumber"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-2" }, [
                                _vm._v(
                                  "Es wird dir ein einmaliger Sicherheitscode zur Bestätigung übermittelt."
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "font-weight-bold mt-5" },
                                [_vm._v("Geheime Kontodaten")]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "Persönliche Daten werden nur dann für einen Arbeitgeber sichtbar, wenn du sie ihm\n\t\t\t\t\t\tfreigibst:\n\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "mt-4" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "2" } },
                                    [
                                      _c(
                                        "FormGroup",
                                        [
                                          _c("SalutationSelect", {
                                            model: {
                                              value:
                                                _vm.personalData.salutation,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.personalData,
                                                  "salutation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "personalData.salutation"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-2 mt-md-0",
                                      attrs: { md: "2" }
                                    },
                                    [
                                      _c("b-input", {
                                        attrs: { placeholder: "Titel" },
                                        model: {
                                          value: _vm.personalData.title,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.personalData,
                                              "title",
                                              $$v
                                            )
                                          },
                                          expression: "personalData.title"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-2 mt-md-0",
                                      attrs: { md: "3" }
                                    },
                                    [
                                      _c(
                                        "FormGroup",
                                        [
                                          _c("b-input", {
                                            attrs: { placeholder: "Vorname" },
                                            model: {
                                              value: _vm.personalData.firstName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.personalData,
                                                  "firstName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "personalData.firstName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-2 mt-md-0",
                                      attrs: { md: "3" }
                                    },
                                    [
                                      _c(
                                        "FormGroup",
                                        [
                                          _c("b-input", {
                                            attrs: { placeholder: "Nachname" },
                                            model: {
                                              value: _vm.personalData.lastName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.personalData,
                                                  "lastName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "personalData.lastName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-2 mt-md-0",
                                      attrs: { md: "2" }
                                    },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          placeholder: "Titel nachgestellt"
                                        },
                                        model: {
                                          value:
                                            _vm.personalData.appendingTitle,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.personalData,
                                              "appendingTitle",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "personalData.appendingTitle"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-4" },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "FormGroup",
                                            {
                                              attrs: {
                                                label: "Staatsbürgerschaft(en)"
                                              }
                                            },
                                            [
                                              _c("CountryAutocomplete", {
                                                attrs: { meta: _vm.meta },
                                                model: {
                                                  value:
                                                    _vm.personalData
                                                      .citizenships,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.personalData,
                                                      "citizenships",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "personalData.citizenships"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "mt-3 mt-md-0",
                                              attrs: {
                                                label: "Wann bist du geboren?"
                                              }
                                            },
                                            [
                                              _c("DateInputs", {
                                                attrs: {
                                                  "show-incomplete-error": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.personalData
                                                      .dateOfBirth,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.personalData,
                                                      "dateOfBirth",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "personalData.dateOfBirth"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.showNameDateOfBirthWarning
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "font-weight-extra-bold"
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tAchtung: Geburtsdatum sowie Vor- und Nachname können später nicht mehr geändert werden.\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.domicileNecessary
                      ? _c(
                          "section",
                          [
                            _c("h3", [_vm._v("Dein Wohnort")]),
                            _vm._v(" "),
                            _c("PostalCodeEdit", {
                              attrs: {
                                meta: _vm.meta,
                                coloring: false,
                                "with-country-selection": ""
                              },
                              model: {
                                value: _vm.domicile,
                                callback: function($$v) {
                                  _vm.domicile = $$v
                                },
                                expression: "domicile"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "legitimation--continue" },
                [
                  _vm.checkData
                    ? [
                        !_vm.saving
                          ? _c("Button", {
                              staticClass: "mr-3 mb-3 mb-md-0",
                              attrs: {
                                text: "Daten ändern",
                                secondary: "",
                                icon: "edit"
                              },
                              on: {
                                click: function($event) {
                                  _vm.checkData = false
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Button", {
                    attrs: {
                      text: _vm.checkData
                        ? "Bestätigen / SMS-Code anfordern"
                        : "Weiter",
                      icon: "checkmark",
                      loading: _vm.saving,
                      disabled: _vm.saveButtonDisabled
                    },
                    on: {
                      click: function($event) {
                        return _vm.save(false)
                      }
                    }
                  })
                ],
                2
              )
            ],
            2
          ),
      _vm._v(" "),
      _vm.showInvalidFields
        ? _c(
            "PopUp",
            {
              attrs: {
                title: "Ungültige Eingaben",
                "ok-text": "OK",
                "hide-cancel": ""
              },
              on: {
                ok: function($event) {
                  _vm.showInvalidFields = false
                },
                hidden: function($event) {
                  _vm.showInvalidFields = false
                }
              }
            },
            [
              _c("p", [_vm._v("Bitte überprüfe die folgenden Felder:")]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "content-list" },
                _vm._l(_vm.invalidFields, function(field) {
                  return _c("li", { key: field }, [_vm._v(_vm._s(field))])
                }),
                0
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "color-primary font-weight-extra-bold" }, [
      _vm._v("\n\t\t\t\tBitte prüfe deine Angaben."),
      _c("br"),
      _vm._v(
        "\n\t\t\t\tDer Vor- und Nachname und das Geburtsdatum können nachträglich nicht mehr geändert werden.\n\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "font-weight-extra-bold" }, [
        _vm._v("Sicherheits-Code anfordern:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-2" }, [
        _vm._v(
          "\n\t\t\t\t\t\t\tUm dein Konto zu schützen, wird eine Mobilnummer hinterlegt. Sollten auffällige\n\t\t\t\t\t\t\tZugriffsversuche auf dein Profil erfolgen oder deine Zugangsdaten verloren gehen, wird\n\t\t\t\t\t\t\tdir über die Mobilnummer ein Sicherheitscode gesendet.\n\t\t\t\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "content-list mt-3" }, [
        _c("li", [
          _vm._v(
            "Deine Telefonnummer wird von skilldoo nicht an Dritte weitergegeben."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("skilldoo wird dich nicht über diese Telefonnummer anrufen.")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }